export enum PaymentMethod {
  SwapMachine = 1,
  Online = 2,
  Cash = 3,
  Defer = 4,
}
